import { Button, Group } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import React, { ReactNode } from "react";

import { Card, CardProps, Title } from "@components";

interface TitleCardProps extends Omit<CardProps, "title"> {
  title: ReactNode;
  buttonText?: string;
  onButtonClick?: () => void;
  theme?: "light" | "dark";
}

export function TitleCard(props: TitleCardProps) {
  const {
    title,
    buttonText,
    onButtonClick,
    theme = "dark",
    ...cardProps
  } = props;

  return (
    <Card
      bg={theme === "dark" ? "layoutDark" : "layoutLight"}
      mt="xs"
      px={{ base: "xl", md: "xxl" }}
      py={{ base: "lg", md: "xxl" }}
      {...cardProps}
    >
      <Group justify="space-between">
        <Title
          c={theme === "dark" ? "fontLight" : "fontDark"}
          order={2}
          size={{ base: "h4", md: "h2" }}
        >
          {title}
        </Title>

        {buttonText && (
          <>
            <Button
              variant="glass-square"
              onClick={onButtonClick}
              size="xs"
              h="70px"
              my="calc(-1 * var(--mantine-spacing-lg))"
              mr="calc(-1 * var(--mantine-spacing-lg))"
              px="md"
              hiddenFrom="md"
            >
              <IconChevronRight
                size={28}
                style={{ transform: "translateX(2px)" }}
              />
            </Button>

            <Button variant="glass" onClick={onButtonClick} visibleFrom="md">
              {buttonText}
            </Button>
          </>
        )}
      </Group>
    </Card>
  );
}
